var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutDirectlyFromPotatoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 35,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#FF6B00"
  }, "CUT DIRECTLY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 65,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#FF6B00"
  }, "FROM POTATOES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutDirectlyFromPotatoes);
export default __webpack_public_path__ + "static/media/cut-directly-from-potatoes.7ddc4d81cd5b7ff71062d0c0d22f003b.svg";
export { ForwardRef as ReactComponent };